module.exports = __webpack_public_path__ + "img/arek.13a71122.gif";